<div style="width: 100vw; height: 100vh; z-index: 1000; background-color: white; position: absolute">
  <section class="flex-column-centered fullwidth margin-bottom-40">
    <h1 class="text-center bd-blue fullwidth semibold" id="szolgatlatasaink">Belépés</h1>
    <div class="flex-row-centered fullwidth"><hr class="" /></div>
    <br />

    <div class="flex-row-centered wrap">
      <div class="margin-bottom-20 flex-column-centered">
        <form
          [formGroup]="loginForm"
          class="flex-column-centered wrap fullwidth margin-bottom-20"
          style="margin: 0 auto"
        >
          <div class="margin-bottom-10">
            <input
              type="text"
              class="bd-input"
              placeholder="Felhasználónév"
              formControlName="email"
              [class.errorMsgInput]="isSubmitted && controls().email.errors"
            />
            @if (isSubmitted && controls().email.errors) {
              <div>
                @if (controls().email.errors && controls().email.errors.name) {
                  <small class="errorMsg"> Hibás név. </small>
                }
              </div>
            }
          </div>
          <div class="">
            <input
              type="password"
              class="bd-input"
              placeholder="Jelszó"
              formControlName="password"
              [class.errorMsgInput]="isSubmitted && controls().password.errors"
            />
            @if (isSubmitted && controls().password.errors) {
              <div>
                @if (controls().password.errors && controls().password.errors.password) {
                  <small class="errorMsg"> Hibás jelszó. </small>
                }
              </div>
            }
          </div>
        </form>

        <div class="bd-button" (click)="submit()">Belépek</div>
      </div>
    </div>
  </section>
</div>
